import { render, staticRenderFns } from "./LeadCommunicationDeliveryStatus.vue?vue&type=template&id=062d08cb&scoped=true&"
import script from "./LeadCommunicationDeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./LeadCommunicationDeliveryStatus.vue?vue&type=script&lang=js&"
import style0 from "./LeadCommunicationDeliveryStatus.vue?vue&type=style&index=0&id=062d08cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062d08cb",
  null
  
)

export default component.exports